<template>
  <roe-error-message :field="design.employer_other_annual_service_reqt">
    <v-select
      v-model="design.$model.employer_other_annual_service_reqt"
      name="employer_other_annual_service_reqt"
      :options="[
        { code: 0, label: 'None Required' },
        { code: 1, label: 'Months Required' },
        { code: 2, label: 'Hours Required' }
      ]"
      :reduce="label => label.code"
      required
      @change="resetAttributes(design, 'employer_other_annual_service_reqt')"
    >
    </v-select>
  </roe-error-message>
</template>

<script>
import RoeErrorMessage from "@/components/_shared/inputs/ErrorMessage";
import ResetDesignAttributesMixin from "@/components/_shared/inputs/design/_mixins/ResetDesignAttributesMixin";
export default {
  name: "RoeEmployerOtherServiceReqAppliesSelect",
  components: { RoeErrorMessage },
  mixins: [ResetDesignAttributesMixin],
  props: {
    design: Object
  }
};
</script>
